import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../../config/firebase';
import { ScannedTTR } from './types';

export type ResolutionPath = 'exact' | 'fallback' | 'not_found' | 'invalid';

/**
 * Fire-and-forget scan event for the future aggregated data feed (Bloomberg-for-
 * collectibles primitive #26). Logged once per page load. NEVER blocks render â€”
 * any failure is swallowed. No PII: no IP, no precise location, no auth state.
 *
 * Writes whitelabelbuddy/scanEvents/{auto-id} (anonymous create allowed by rule;
 * the rule forbids a `userId` field and requires scannedAt == request.time).
 */
export function logScanEvent(
  rawTtrCode: string | undefined,
  scanned: ScannedTTR | null,
  resolutionPath: ResolutionPath,
): void {
  try {
    const isMobile = typeof window !== 'undefined' && window.innerWidth < 768;
    const payload: Record<string, unknown> = {
      ttrCode: scanned ? scanned.ttrCode : (rawTtrCode || '').trim().toUpperCase(),
      parsed: scanned
        ? {
            boardId: scanned.boardId,
            position: scanned.position,
            condition: scanned.condition,
            holder: scanned.holder,
            copy: scanned.copy,
          }
        : null,
      resolutionPath,
      scannedAt: serverTimestamp(),
      userAgent:
        typeof navigator !== 'undefined' ? String(navigator.userAgent).slice(0, 300) : null,
      isMobile,
      referrer: typeof document !== 'undefined' && document.referrer ? document.referrer : null,
    };
    // Intentionally not awaited â€” fire-and-forget.
    void addDoc(collection(db, 'scanEvents'), payload).catch(() => {});
  } catch {
    // never throw from analytics
  }
}
